import {Nullish} from 'shared/web';

import {numberFormatter} from './numberFormatter';

export const mileageFormatter = (value: number | Nullish) => `${numberFormatter(value)} km`;
